export function configureCharts(Highcharts) {
    /* display negative numbers on logarithmic chartss*/
    (function (H) {
        H.addEvent(H.Axis, 'afterInit', function () {
            const logarithmic = this.logarithmic;

            if (logarithmic && this.options.custom.allowNegativeLog) {

                // Avoid errors on negative numbers on a log axis
                this.positiveValuesOnly = false;

                // Override the converter functions
                logarithmic.log2lin = num => {
                    const isNegative = num < 0;

                    let adjustedNum = Math.abs(num);

                    if (adjustedNum < 10) {
                        adjustedNum += (10 - adjustedNum) / 10;
                    }

                    const result = Math.log(adjustedNum) / Math.LN10;
                    return isNegative ? -result : result;
                };

                logarithmic.lin2log = num => {
                    const isNegative = num < 0;

                    let result = Math.pow(10, Math.abs(num));
                    if (result < 10) {
                        result = (10 * (result - 1)) / (10 - 1);
                    }
                    return isNegative ? -result : result;
                };
            }
        });
    }(Highcharts));

    Highcharts.setOptions({
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        colors: [
            '#F36633',
            'rgba(84, 79, 64, 1)',
            'rgba(84, 79, 64, 0.7)',
            'rgba(84, 79, 64, 0.5)',
            'rgba(84, 79, 64, 0.3)',
            'rgba(84, 79, 64, 0.1)'
        ],
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
                states: {
                    hover: {
                        halo: {
                            size: 0
                        }
                    }
                },
                borderWidth: 0
            }
        }
    });
}